import {
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiCheckCircleOutline,
    mdiInformationOutline,
} from '@lumapps/lumx/icons';
import { Kind } from '@lumapps/lumx/react';
import { GLOBAL } from '@lumapps/translations';

export const INFO_PANEL = 'info-panel';

/** CSS class marking the info panel content block (shared between render, serialize and deserialize). */
export const CLASSNAME = 'wrex-content-info-panel';

/** Allowed info panel kinds (maps to the DS `Message` `kind` prop). */
export const INFO_PANEL_KINDS = [Kind.info, Kind.warning, Kind.error, Kind.success] as const;

/** Default kind applied to a freshly created info panel. */
export const DEFAULT_INFO_PANEL_KIND = Kind.info;

/** Icon shown for each info panel kind (mirrors the DS `Message` leading icon). */
export const KIND_ICONS: Record<string, string> = {
    [Kind.info]: mdiInformationOutline,
    [Kind.warning]: mdiAlertCircleOutline,
    [Kind.error]: mdiAlertOutline,
    [Kind.success]: mdiCheckCircleOutline,
};

/** Label translation key for each info panel kind. */
export const KIND_LABELS: Record<string, string> = {
    [Kind.info]: GLOBAL.INFORMATION,
    [Kind.warning]: GLOBAL.WARNING,
    [Kind.error]: GLOBAL.ERROR,
    [Kind.success]: GLOBAL.SUCCESS,
};
